import { render, staticRenderFns } from "./workerDataBase.vue?vue&type=template&id=0a6cf06d&"
import script from "./workerDataBase.vue?vue&type=script&lang=js&"
export * from "./workerDataBase.vue?vue&type=script&lang=js&"
import style0 from "./workerDataBase.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports